module.exports = __webpack_public_path__ + "img/lietuvaskaito-original-960.52f65dc6.webp";